import Slider from "./components/Slider";
import functions from "./functions";

$(function () {


  $('.form-guide').each((i, elem) => {
    elem._formGuide = new FormGuide(elem);
  });


  $(document).on('click', '[data-scroll-to]', e => {
    e.preventDefault();
    const $this = $(e.target);
    let scrollTo = $this.attr('data-scroll-to').split(',');
    functions.scrollToElement(scrollTo[0], scrollTo[1] || 0);
  });

  if($('#hero-slider')[0]) {
    const length = $('#hero-slider').children('.keen-slider__slide').length;
    new Slider($('#hero-slider'), {
      rubberband: false,
      loop: length > 1 ? true : false,
      arrows: length > 1 ? true : false,
      pager: length > 1 ? true : false,
      autoplay: 6000,
      slides: {
        perView: 1,
        spacing: 0,
      },
      defaultAnimation: {
        duration: 1200,
      },
    });
  }

  let pagesSlider = [];

  if($('[id^=pages-slider]')[0]) {
    $('[id^=pages-slider]').each((i, elem) => {
      pagesSlider[i] = new Slider('#' + $(elem).attr('id'), {
        rubberband: false,
        loop: true,
        arrows: true,
        pager: false,
        slides: {
          perView: 4,
          spacing: 20,
        },
        defaultAnimation: {
          duration: 1200,
        },
        breakpoints: {
          '(max-width: 1390px)': {
            slides: {
              perView: 3,
              spacing: 20,
            },
          },
          '(max-width: 768px)': {
            slides: {
              perView: 2.2,
              spacing: 20,
            },
          },
          '(max-width: 560px)': {
            slides: {
              perView: 1.2,
              spacing: 20,
            },
          },
        }
      });
    });
  }

  let objectsSlider = [];

  if($('[id^=objects-slider]')[0]) {
    $('[id^=objects-slider]').each((i, elem) => {
      objectsSlider[i] = new Slider('#' + $(elem).attr('id'), {
        rubberband: false,
        loop: true,
        arrows: true,
        pager: true,
        slides: {
          perView: 3,
          spacing: 0,
        },
        defaultAnimation: {
          duration: 1200,
        },
        breakpoints: {
          '(max-width: 1390px)': {
            slides: {
              perView: 2.2,
            },
          },
          '(max-width: 768px)': {
            slides: {
              perView: 1.2,
            },
          },
        }
      });
    });
  }

  if(functions.getCookie('cookie_usage') !== 'accepted') {
    $("#cookie-bar").removeClass('d-none');
  }

  $('#cookie-bar-accept').on('click', function (e) {
    functions.setCookie('cookie_usage', 'accepted');
    $("#cookie-bar").addClass('d-none');
  });

  functions.favoritesLabel();

  const $wpGallerys = $('.wp-block-gallery');

  $wpGallerys.each((index, wpGallery) => {
    let $wpGallery = $(wpGallery);
    const $wpGalleryLinks = $wpGallery.find('.wp-block-image');
    const wpGalleryArray = $wpGalleryLinks.map((i, elem) =>
    {
        const $elem = $(elem);
        const $img = $elem.find('img');
        let imgs = $img.attr('src').split(', ');
        // let imgs = $img.attr('srcset').split(', ');
        let sizes = $.map(imgs, img =>
        {
            let size = img.match(/(\d+)w$/);
            return size ? +size[1] : 9999;
        });
        let minSize = sizes.indexOf(Math.min.apply(Math, sizes));
        minSize = minSize > -1 ? minSize : 0;

        let img = imgs[minSize].replace(/ \d+w$/, '');
        return {
            src: $img.attr('src'),
            thumb: img
        };
    });

    function openGallery(index) {
        const gallery = $wpGallery.data('lightGallery');
        if (gallery) {
            gallery.index = index;
            gallery.build(index);
        } else {
            $wpGallery.lightGallery({
                dynamic: true,
                thumbnail: true,
                toogleThumb: false,
                thumbWidth: 130,
                thumbMargin: 10,
                download: false,
                autoplay: false,
                preload: 2,
                index: index,
                dynamicEl: wpGalleryArray.toArray()
            });
        }
    }

    $wpGallery.on('click', '.wp-block-image', e => {
        e.preventDefault();
        openGallery($wpGalleryLinks.index(e.currentTarget));
    });

    if ($wpGallery.closest('.content-gallery').length && $wpGalleryLinks.length) {
        const language = document.documentElement.lang || '';
        const label = language.toLowerCase().startsWith('en') ? 'Gallery' : 'Galerija';
        const $button = $('<button type="button" class="btn gallery-button text-shadow"></button>');
        $button.text(label + ' (' + $wpGalleryLinks.length + ')');
        $button.on('click', e => {
            e.preventDefault();
            openGallery(0);
        });
        $wpGallery.append($button);
    }
  });

 

  
});
